/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DestroyBase } from '../../../shared/base-classes/destroy-component-base';
import { CompanyDetails } from '../../../shared/models/company-details';
import {
  CRFRecordMappingResponse,
  CRFAppliedLead,
  ApplyCRFLeadRequest,
  ApplyCRFLeadResponse,
} from '../models/crf-match.model';

@Injectable({
  providedIn: 'root',
})
export class SMEService extends DestroyBase {
  private apiUrl = environment.apiBaseUrl.endsWith('/')
    ? environment.apiBaseUrl.trimEnd()
    : environment.apiBaseUrl;
  private http: HttpClient = inject(HttpClient);

  getSMEBusinessRecord(): Observable<CompanyDetails> {
    return this.http.get<CompanyDetails>(`${this.apiUrl}/api/sme/business`);
  }

  createSMEBusinessRecord(payload: any): Observable<CompanyDetails> {
    return this.http.post<CompanyDetails>(
      `${this.apiUrl}/api/sme/business`,
      payload,
    );
  }

  updateSMEBusinessRecord(payload: any): Observable<CompanyDetails> {
    return this.http.patch<CompanyDetails>(
      `${this.apiUrl}/api/sme/business`,
      payload,
    );
  }

  deleteSMEBusinessRecord(): Observable<any> {
    return this.http.delete(`${this.apiUrl}/api/sme/business`);
  }

  getCRFMatches(): Observable<CRFRecordMappingResponse> {
    return this.http.get<CRFRecordMappingResponse>(
      `${this.apiUrl}/api/sme/crf/matches`,
    );
  }

  applyCRFLead(payload: ApplyCRFLeadRequest): Observable<ApplyCRFLeadResponse> {
    return this.http.post<ApplyCRFLeadResponse>(
      `${this.apiUrl}/api/sme/crf/lead`,
      payload,
    );
  }

  getAppliedCRFLeads(): Observable<CRFAppliedLead[]> {
    return this.http.get<CRFAppliedLead[]>(`${this.apiUrl}/api/sme/crf/lead`);
  }
}
